import {useTranslation} from "../i18n";
import "../finance/financeOperations.css";

export const ServerPagination = ({
    count,
    page,
    pageSize = 20,
    previous,
    next,
    pending = false,
    onPageChange,
}) => {
    const {t} = useTranslation();
    const total = Math.max(0, Number(count) || 0);
    const currentPage = Math.max(1, Number(page) || 1);
    const size = Math.max(1, Number(pageSize) || 20);
    const pageFirst = (currentPage - 1) * size + 1;
    const hasPageRange = total > 0 && pageFirst <= total;
    const first = hasPageRange ? pageFirst : 0;
    const last = hasPageRange ? Math.min(currentPage * size, total) : 0;

    return (
        <nav className="finance-pagination" aria-label={t("common.pagination.ariaLabel")}>
            <p>{t("common.pagination.shown", {first, last, total})}</p>
            <div>
                <button type="button" className="admin-button admin-button-secondary" disabled={pending || previous === null || previous === undefined} onClick={() => onPageChange(previous)}>
                    {t("common.pagination.previous")}
                </button>
                <span>{t("common.pagination.page", {page: currentPage})}</span>
                <button type="button" className="admin-button admin-button-secondary" disabled={pending || next === null || next === undefined} onClick={() => onPageChange(next)}>
                    {t("common.pagination.next")}
                </button>
            </div>
        </nav>
    );
};
